module.exports = {"en":["English","ไทย","한국어","Français","中文","Bahasa Malaysia","日本語","Deutsch","Nederlands","Pусский","Español","Norsk","Português","Italiano","Bahasa Indonesia","Tiếng Việt"],"th":["English","ไทย","中文"],"zh":["English","ไทย","中文"]}


//////////////////
// WEBPACK FOOTER
// ./src/json/languages.json
// module id = 1471
// module chunks = 47